import { useEffect, useState } from 'react'
import { Flex, ExpandableLabel, CardFooter, Text } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import { LotteryRound } from 'state/types'
import FooterExpanded from './FooterExpanded'
import { getDrawnDate } from 'views/Lottery/helpers'
import styled, { useTheme } from 'styled-components'
import { LotteryRoundExpanded } from '../RewardBrackets'

const CustomFlex = styled(Flex)`
  button {
    padding: 0px;
    height: auto;
  }
`

interface PreviousRoundCardFooterProps {
  lotteryNodeData: LotteryRoundExpanded
  lotteryId: string
}

const PreviousRoundCardFooter: React.FC<React.PropsWithChildren<PreviousRoundCardFooterProps>> = ({
  lotteryNodeData,
  lotteryId,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const theme = useTheme()

  useEffect(() => {
    if (!lotteryId) {
      setIsExpanded(false)
    }
  }, [lotteryId])
  const {
    t,
    currentLanguage: { locale },
  } = useTranslation()

  return (
    <CardFooter p="0" style={{borderTop: `1px solid ${theme.colors.cardBorder}`}}>
      {isExpanded && <FooterExpanded lotteryNodeData={lotteryNodeData} lotteryId={lotteryId} />}
      <Flex p="20px" alignItems="center" justifyContent={lotteryNodeData ? "space-between" : "center"}>
        {lotteryNodeData && <Text fontSize="14px">
          {t('Drawn')} {getDrawnDate(locale, lotteryNodeData.endTime)}
        </Text>}
        <CustomFlex>
        <ExpandableLabel
          expanded={isExpanded}
          onClick={() => {
            if (lotteryId) {
              setIsExpanded(!isExpanded)
            }
          }}
        >
          {isExpanded ? t('Hide') : t('Show details')}
        </ExpandableLabel>
        </CustomFlex>
      </Flex>
    </CardFooter>
  )
}

export default PreviousRoundCardFooter
